import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import PieChart from "components/Graphs/PieChart";
import BarChart from "components/Graphs/BarChart";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import WordCloud from "components/Graphs/WordCloud";

const useStyles = makeStyles((theme) => ({
  root: {
    border: "none",
    backgroundColor: "#f9f9f9",
    borderRadius: 0,
  },
  pad1: {
    paddingTop: "25px",
    [theme.breakpoints.up("sm")]: {
      paddingLeft: "40px",
      paddingRight: "40px",
    },
  },
  pad2: {
    [theme.breakpoints.up("sm")]: {
      paddingLeft: "75px",
      paddingRight: "75px",
    },
  },
}));

const GraphCard = ({ graphType, graphData, title, questionText }) => {
  const classes = useStyles();

  if (!graphType || !graphData) return null;

  let graph = null;

  switch (graphType) {
    case "PIE":
      graph = (
        <PieChart
          chartData={{ data: graphData.data, labels: graphData.labels }}
        />
      );
      break;
    case "BAR":
      graph = (
        <BarChart
          chartData={{ data: graphData.data, labels: graphData.labels }}
        />
      );
      break;
    case "WORD_CLOUD": {
      /**
       * Handles both old and new word cloud data formats.
       * Chart data for word cloud used to be an object with `data`,
       * but now it's an array of words.
       */
      const data = Array.isArray(graphData) ? graphData : graphData.data;
      graph = (
        // Div is necessary or else wordcloud infinitely stretches page
        <div>
          <WordCloud words={data} />
        </div>
      );
      break;
    }
    default:
      break;
  }

  return (
    graph && (
      <Card className={classes.root} elevation={0}>
        <CardHeader
          title={
            <Typography component="h3" variant="h4">
              {questionText}
            </Typography>
          }
          disableTypography
          className={classes.pad1}
        />
        <CardContent className={classes.pad2}>
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={9}>
              <div className="graph-title">
                <span>{title}</span>
              </div>
              {graph}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    )
  );
};

export default GraphCard;
